import React from 'react'
import { Skeleton, SkeletonProps } from '@material-ui/lab'

type TableLoaderProps = {
  size?: number
  height?: number
  animation?: SkeletonProps['animation']
}

const TableLoader = ({ size = 6, height = 82, animation = 'wave' }: TableLoaderProps) => {
  return (
    <>
      {Array.from(Array(size)).map((_, index) => (
        <Skeleton key={index} height={height} animation={animation} />
      ))}
    </>
  )
}

export default TableLoader
